/**
 * Equivalent to the deprecated cm_activate() function in clickMenu.js.
 * @param url
 * @param escPageId
 * @param targetParent
 * @param openInNewWindow
 */
import {openLinkInNewWindow} from "./nav";

export function loadUrl(url, escPageId, targetParent, openInNewWindow) {
    const { _pgId : docPgId } = GlobalEnt.pageData;
    const { _pgId : parentPgId } = parent.GlobalEnt.pageData;
    if (escPageId) {
        url += '&referer=' + escPageId;
    } else if (targetParent && parentPgId) {
        url += '&referer=' + encodeURIComponent(parentPgId);
    } else if (!targetParent && docPgId) {
        url += '&referer=' + encodeURIComponent(docPgId);
    }

    if (openInNewWindow) {
        openLinkInNewWindow(url, true);
        return;
    }

    if (targetParent)
        parent.document.location = url;
    else
        document.location = url;
}

/**
 Get all query (aka search) parameters to the given document as
 an object map.
 This only works for GET requests.
 */
export function getQueryParams(aDocument, paramName) {
    let loc = aDocument.location.search;
    if (loc == null || loc.length < 1)
        return [];

    let parts = loc.substring(1).split('&');  //clip of leading '?' then split
    let map = new Object();  //will be used as a hash map
    let i;
    for (i = 0; i < parts.length; i++) {
        let part = parts[i];
        if (part.length > 0) {
            let eq = part.indexOf('=');
            if (eq != -1) {
                let param = part.substring(0, eq);
                if (eq + 1 < part.length)
                    map[param] = part.substring(eq + 1);
                else
                    map[param] = '';
            } else
                map[part] = '';
        }
    }

    return map;
}

export function removeQueryParam(url, paramName) {
    if (typeof url != 'string')
        url = new String(url);

    if (url.indexOf(paramName + '=') != -1) {
        let pat = new RegExp('&?' + paramName + '=[^&]*');
        return url.replace(pat, "");
    }
    return url;
}

/*Add a query parameter to the given URL string.  Example:
	document.location = setQueryParam(document.location, 'enableFoo', 'yes')
	*/
export function setQueryParam(url, paramName, paramValue) {
    if (typeof url != 'string')
        url = new String(url);

    //escape the param value
    if (window.encodeURIComponent)
        paramValue = window.encodeURIComponent(paramValue);
    else
        paramValue = window.escape(paramValue);

    if (url.indexOf(paramName + '=') != -1) {
        let pat = new RegExp(paramName + '=[^&]*');
        return url.replace(pat, paramName + '=' + paramValue);
    } else {
        //if the url ends with an anchor id (eg http://foo/bar?a=b#yada)
        //then the query parameter needs to be inserted before the # rather than
        //appended at the very end
        let prefix;
        let suffix;
        let hashIdx = url.indexOf('#');
        if (hashIdx != -1) {
            prefix = url.substring(0, hashIdx);
            suffix = url.substring(hashIdx);
        } else {
            prefix = url;
            suffix = '';
        }

        let sep = '&';
        if (url.indexOf('?') == -1)
            sep = '?';

        return prefix + sep + paramName + '=' + paramValue + suffix;
    }
}

/**Strip a url like "http://foo:8080/bar?yada=yes" to: "/bar?yada=yes"*/
export function stripURLHost(url) {
    //ensure string
    url = new String(url);
    let index = url.indexOf("://");
    if (index > 0) {
        index = url.indexOf("/", index + "://".length);
        if (index > 0)
            url = url.substring(index);
    }

    return url;
}

export function makeFileNameUrlSafe(fileName) {
    //escape the param value
    if (window.encodeURIComponent)
        return window.encodeURIComponent(fileName);
    else
        return window.escape(fileName);
}

export function getFormattedUrlFromParams(url, params) {
    for (const key in params) {
        for (let i = 0; i < 2; i++) {
            if (url.includes(`${key}={${i}}`)) {
                url = url.replace(`{${i}}`, params[key]);
            }
        }
    }
    return url;
}